import { SEARCH_STRING_KEY } from '@yme/utils/bloomreach';
export function getNoResultDescription(label, value) {
    if (value) {
        return label?.replace(SEARCH_STRING_KEY, `"${value}"`);
    }
    return label?.replace(SEARCH_STRING_KEY, '');
}
